module.exports = __webpack_public_path__ + "static/mvsm-2788d2795ed6be7fa22b8e0f1322d4c2.png";